export default __webpack_public_path__ + "static/media/findprofessionals@2x.75f1544c.png";